export const DIGITALK_FRAME_ID = "digitalk-chat-frame";
export const DIGITALK_CONTAINER_ID = "digitalk-chat";
export const DIGITALK_SCRIPT_URL = "https://liber-chat.digitalk.com.br/chat.js";

/** Elementos que o widget só renderiza com o chat aberto */
export const OPEN_CHAT_SELECTOR = ".digitalk-title, form";

export const CHAT_FRAME_SRCDOC =
  '<!DOCTYPE html><html><head><meta charset="utf-8"></head>' +
  '<body style="margin:0;background:transparent;overflow:hidden">' +
  `<div id="${DIGITALK_CONTAINER_ID}"></div></body></html>`;

export const OPEN_CHAT_SIZE = { width: 440, height: 760 };
export const CLOSED_CHAT_SIZE = { width: 96, height: 96 };
